<template>
  <div class="pa-0">
      <template v-if="isPartnerHost">
        <LoginPartner />
      </template>
      <template v-else-if="hostname.includes('myboardpage')">
        <LoginBoard />
      </template>
      <template v-else>
        <LoginExisting />
      </template>
  </div>
</template>
<script>
import LoginBoard from "@/components/LoginBoard.vue";
import LoginExisting from "@/components/LoginExisting.vue";
import LoginPartner from "@/components/LoginPartner.vue";
import Login from "@/components/Login.vue";
export default {
  name: "LoginCommon",
  mounted: function() {
    // 🚨🚨 IMPORTANT NOTICE 🚨🚨
    // Any change here REQUIRES updating the file below
    // import { handleLogin } from '@/Services/loginHelper.js';
    console.log('%c🚨🚨 IMPORTANT NOTICE 🚨🚨', 'color: red; font-size: 20px; font-weight: bold;');
    console.log('%cAny change here REQUIRES updating the file below', 'color: #d32f2f; font-size: 18px; font-weight: 600;');
    console.log('%cimport { handleLogin } from \'@/Services/loginHelper.js\';', 'color: #1565c0; font-size: 16px; font-weight: 500;');
  },
  components: {
    LoginBoard,
    LoginExisting,
    LoginPartner,
    Login,
  },
  data() {
    return {
      hostname: window.location.hostname,
      node_env: process.env.NODE_ENV.toLowerCase().trim(),
    };
  },
  computed: {
    // partner.starrboard.com OR partner.compliance-staging.tectalik.com OR partner.localhost
    isPartnerHost() {
      const parts = this.hostname.split(".");
      return parts[0] === "partner";
    },
  },
  methods: {

  },
};
</script>